import React from "react";  //keep for backward compatibility with older React versions
import RiskGraph from "../../components/risk-graph";
import GeneTable from "../../components/gene-table";

const Lat_Epi_Results = (props) => {
  return (
    <div>
      <div className="title-margins">
        <h2>
          {props.userName
            ? `${props.userName}'${props.nameEndsWithS ? "" : "s"}`
            : ""}{" "}
          Results for Tennis Elbow (Lateral Epicondylopathy)
        </h2>
        {/* <h5>[<a href="https://pubmed.ncbi.nlm.nih.gov/33017352/">Kim et al., 2021</a>]</h5> */}
      </div>
      <div className="card">
        <RiskGraph tag="lat_epi" />
        <p className="mb-0">
          The bar graph shows your risk of tennis elbow compared to the risk for
          an average person (1.00). Your risk is calculated based on your
          genotypes at the two DNA polymorphisms shown in the table below.
        </p>
      </div>
      <div className="card">
        <p>
          rs13127477 is near three members of the SIBLING gene family:{" "}
          <i>IBSP</i>, <i>MEPE</i>, and <i>SPP1</i>. IBSP (bone sialoprotein)
          mediates integrin-dependent cell adhesion, migration and matrix
          mineralization, which are cellular processes involved in lateral
          epicondylopathy. IBSP also influences osteoblast and osteoclast
          differentiation and activity, potentially affecting bone-tendon
          interface remodeling in response to repetitive loading. MEPE regulates
          bone turnover, mineralization and vascularization, processes relevant
          to tendon repair capacity and the altered neovascular response
          observed in tendinopathy. SPP1 binds integrin and CD44 to mediate cell
          adhesion and chemotaxis, and is involved in pathological fibroblast
          infiltration, vascular hyperplasia, and disorganized collagen
          deposition that are hallmarks of angiofibroblastic tendinosis observed
          in lateral epicondylopathy.
        </p>
        <p>
          Increased expression of the SIBLING proteins is associated with
          increased risk for lateral epicondylopathy. Specifically, the risk
          allele for rs13127477 is also associated with increased expression of
          all three SIBLING genes. This in turn, suggests that excessive
          entheseal remodeling, mineralization, and pathological matrix
          regulation by SIBLING genes contributes to disease susceptibility.
        </p>
        <p>
          rs138254824 is near the <i>NEDD9</i> and <i>TMEM170B</i> genes. NEDD9
          is a scaffold protein involved with FAK-SRC signaling, integrin
          activation, and focal adhesion dynamics, thereby specifying how cells
          sense and adapt to mechanical loading that are key factors in tendon
          microtrauma and repair. Additionally, NEDD9 has been implicated in
          osteoclastogenesis, which is relevant for bone remodeling at the
          tendon-bone interface under repetitive stress. TMEM170B participates
          in Wnt/β-catenin signaling, a pathway critical for bone formation and
          maintenance, which may influence entheseal adaptation to mechanical
          loading.
        </p>
        <GeneTable tag="lat_epi" cols={["relativeRisk", "gene"]} />
      </div>
    </div>
  );
};

export default Lat_Epi_Results;
